<div class="wq-v2" [style.background]="boxBackgroundColour">
	<div class="title-block-forecast">
		<div class="forecast-desc-box" [style.background]="titleBlockBackgroundColour" >
			<span class="title-block-forecast-text" [style.color]="titleBlockTextColour">
				{{forecastBriefDesc}}
			</span>
		</div>
		<div class="last-updated">
			<app-last-updated-widget 
				*ngIf="pollutionForecastDate"
				[label]="'Last updated'" 
				[updatedDate]="pollutionForecastDate" 
				dateOutFormat="EE, d/M, h aaaaa'm''">
			</app-last-updated-widget>	
		</div>
	</div>

	<div class="content-frame">
		<div class="content-inner-frame">
			<div class="content-title">
				<img class="forecast-indicator-icon" *ngIf="pollLevelIndicatorIcon"
					[src]="'assets/images/WaterqualityForecastIndicator/' + pollLevelIndicatorIcon"
					[alt]="pollutionForecast">
				<span class="forecast-desc-text">
					{{pollutionForecastText}}
				</span>
			</div>
			<div class="desc-block">
				<span class="desc-text">
					{{pollutionDescription}}
				</span>
			</div>
		</div>
		<div>
			<app-key-popup-widget [description]="'How do we forecast?'" [popupTitle]="'How do we forecast?'" >
				<app-key-forecast-popup-content-widget></app-key-forecast-popup-content-widget>
			</app-key-popup-widget>
		</div>
	</div>
</div>
